import React, { useEffect, useState, useRef } from "react";
import { FormControl, Button, Modal, Row, Col, Table } from "react-bootstrap";
import "./Modal.css";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const ModalMessage = ({ modalData }) => {
 
  const handleCloseModal = () => {
    if (modalData?.onCloseModal != null) {
      modalData.onCloseModal();
    }
  };

  return (
    <Modal
      className="incomingModals"
      show={modalData?.showModal ?? false}
      onHide={handleCloseModal}
      size="md"
      backdrop="static"
    >
      <Modal.Header closeButton>
         {modalData?.title}
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col>
            {modalData?.message}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          <CloseIcon /> Chiudi
        </Button>
      </Modal.Footer>      
    </Modal>
  );
};

export default ModalMessage;
